import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CATEGORIES } from "@/lib/categories";
import SuggestCategory from "@/components/SuggestCategory";
import WatchCategoryModal from "@/components/WatchCategoryModal";
import {
  Bell,
  Blocks,
  Boxes,
  ChevronRight,
  Drill,
  Key,
  LayoutGrid,
  Package,
  Sofa,
  Truck,
  Trees,
  Wrench,
} from "lucide-react";

const ICONS = {
  Truck,
  Wrench,
  Sofa,
  Package,
  LayoutGrid,
  Blocks,
  Trees,
  Key,
  Drill,
  Boxes,
};

export default function CategorySidebar({ activeSlug, activeSub, counts = {} }) {
  const navigate = useNavigate();
  const [watchOpen, setWatchOpen] = useState(false);
  return (
    <aside className="stb-card p-3" data-testid="category-sidebar">
      <h3 className="stb-label px-2 pb-2">Kategorie</h3>
      <Link
        to="/"
        className={`block px-3 py-2 stb-h text-sm border-l-2 transition-colors ${
          !activeSlug ? "border-[#FF6B00] text-[#FF6B00]" : "border-transparent text-white hover:text-[#FF6B00]"
        }`}
        data-testid="category-link-all"
      >
        Všechny inzeráty
      </Link>
      <hr className="stb-divider !my-2" />
      <ul className="space-y-1">
        {CATEGORIES.map((c) => {
          const Icon = ICONS[c.icon] || Boxes;
          const active = c.slug === activeSlug;
          return (
            <li key={c.slug}>
              <button
                type="button"
                onClick={() => navigate(`/kategorie/${c.slug}`)}
                className={`w-full flex items-center justify-between gap-2 px-3 py-2 text-left transition-colors stb-h text-sm border-l-2 ${
                  active
                    ? "border-[#FF6B00] text-[#FF6B00] bg-[#1a1a1a]"
                    : "border-transparent text-white hover:text-[#FF6B00]"
                }`}
                data-testid={`category-link-${c.slug}`}
              >
                <span className="inline-flex items-center gap-2">
                  <Icon size={16} />
                  {c.name}
                </span>
                <span className="stb-mono text-xs text-[#A3A3A3]">
                  {counts[c.slug] ?? ""}
                </span>
              </button>
              {active && (
                <ul className="pl-6 pb-2 space-y-1">
                  {c.subcategories.map((sc) => {
                    const subActive = activeSub === sc.slug;
                    return (
                      <li key={sc.slug}>
                        <Link
                          to={`/kategorie/${c.slug}/${sc.slug}`}
                          className={`flex items-center gap-2 text-xs py-1 ${
                            subActive
                              ? "text-[#FF6B00]"
                              : "text-[#A3A3A3] hover:text-white"
                          }`}
                          data-testid={`subcategory-link-${sc.slug}`}
                        >
                          <ChevronRight size={12} />
                          <span>{sc.name}</span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
      {activeSlug && (
        <button
          type="button"
          onClick={() => setWatchOpen(true)}
          className="stb-btn stb-btn-secondary w-full justify-center mt-3 text-xs"
          data-testid="sidebar-watch-category"
        >
          <Bell size={12} /> Sledovat tuto kategorii
        </button>
      )}
      <SuggestCategory />
      {watchOpen && (
        <WatchCategoryModal
          category={activeSlug}
          subcategory={activeSub || null}
          location={null}
          onClose={() => setWatchOpen(false)}
        />
      )}
    </aside>
  );
}
